import ManufactureProducts from './ManufactureProducts';

export default ManufactureProducts;
